import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import Paper from '@material-ui/core/Paper';
import WelcomeCard from "../WelComeCard/index";
import AttGöraTabell from "../Tables/AttgöraTabell";
import Flöde from "../Wall/index";
import CustomScrollbars from "util/CustomScrollbars";
import AttGöraNy from "../AttGöraNy";

const ReactGridLayout = WidthProvider(RGL);

// Lägg till/Ta bort "static: true" på paper för göra boxarna flyttbara eller statiska

export default class StaticElementsLayout extends React.PureComponent {

  render() {
    const { user_Afid, user_Email, user_Notification, user_SeeCasesList, user_SeeContractFlag, user_SeeDialer, user_SeeEndClients, user_SeeOrderList, user_SeeRinglist, user_WeekNotification, user_fnamn, user_id, user_lnamn, user_role } = this.props.authUser;
    return (
      <>
      <div className="w-100 px-2 pt-2">
        {/* <AttGöraTabell/> */}
        <AttGöraNy/>
      </div>
      <ReactGridLayout
        className="layout"
        rowHeight={29}
      >


        <div key="1" 
        // style={{ backgroundColor: '#FFFFFF' }}
         data-grid={{ x: 0, y: 0, w: 12, h: 9, static: true }}>
          <Flöde />
        </div>
      </ReactGridLayout>
      </>
    );
  }
}